<div class="generate-link-container">
  <div class="logo-container">
    <img src="/assets/branding/walgreens-logo-full.png" alt="Walgreens Trusted since 1901" class="walgreens-logo">
  </div>
  <div class="confirmation-header">
    <h2 class="text-left"><strong>{{clinicName}}</strong></h2>
  </div>

  <div class="confirmation-box">
    <div class="confirmation-label">Date:</div>
    <div class="confirmation-number">{{clinicDate | date:'fullDate'}}</div>
  </div>

  <div class="qrcode-content-wrapper">
    <qrcode
      #qrcodeCanvasElement
      [qrdata]="qrCodeDataUrl"
      [scale]="4"
      [width]="250">
    </qrcode>
    <button
      class="btn btn-act btn-lg bg_main_normal_blue"
      [disabled]="!qrCodeDataUrl"
      [matTooltip]="!qrCodeDataUrl ? 'Invalid QR Code' : ''"
      (click)="initiateDownload()"
      mat-button
      mat-flat-button
      type="button"
    >
      Download QR Code
    </button>
    <button
      class="btn btn-act btn-lg main_normal_blue p-2 fs-16 border-radius-100 bg_main_gray_03 mr-2 c-p"
      [disabled]="!qrCodeDataUrl"
      [cdkCopyToClipboard]="qrCodeDataUrl"
      (click)="copyLink()"
      mat-button
      mat-flat-button
      type="button"
    >
      Copy Link
    </button>
  </div>
</div>
